import { render, staticRenderFns } from "./VaccineCardComponent.vue?vue&type=template&id=4edc5bbe"
import script from "./VaccineCardComponent.vue?vue&type=script&lang=js"
export * from "./VaccineCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports